var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar-nav-icon',{on:{"click":_vm.TOGGLE_RIGHT_SIDEBAR_OPEN}},[_c('v-icon',[_vm._v(" "+_vm._s(_vm.isRightSidebarOpen ? 'last_page' : 'first_page')+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }